export default __webpack_public_path__ + "static/media/dice-4.52e63b5a.svg";